module.exports = __webpack_public_path__ + "static/media/social-linkedin.52e178fb.svg";